import { render, staticRenderFns } from "./TextColor.vue?vue&type=template&id=2a90bfc2&scoped=true"
import script from "./TextColor.vue?vue&type=script&lang=js"
export * from "./TextColor.vue?vue&type=script&lang=js"
import style0 from "./TextColor.vue?vue&type=style&index=0&id=2a90bfc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a90bfc2",
  null
  
)

export default component.exports